export class Diocese {
    dioceseId: number;
    publicId: string;
    dioceseName: string;
}


// WEBPACK FOOTER //
// ./src/app/models/diocese.ts